import { useSearch } from "~/core/composables/useSearch";
import LxcError from "~/core/models/LxcError.class";
import type { UseFetchParameters } from "~/core/models/UseFetchParameters.interface";
import {
  Filters,
  type FiltersSelection,
  FiltersType,
  OPERATOR_RSQL_IN,
} from "~/core/models/filters";
import type { DtwinLifeCycleStateMetrics } from "~/modules/dtwin/models/DtwinLifeCycleStateMetrics.type";
import dtwinService from "~/modules/dtwin/services/dtwin.service";

export function useFetchDtwinsMetricsLifeCycleState({
  organizationCode,
}: UseFetchParameters) {
  const appliedFilters: FiltersSelection = new Map([
    [
      Filters.SECTORS,
      { key: "sectorCode", operator: OPERATOR_RSQL_IN, value: [] },
    ],
  ]);

  const { searchParams, filters, setFilter, search, onSearch } = useSearch(
    FiltersType.RSQL,
    appliedFilters,
  );

  const isLoading = ref(false);
  const results: Ref<DtwinLifeCycleStateMetrics | undefined> = ref();
  const error: Ref<LxcError | undefined> = ref();

  async function fetchData() {
    isLoading.value = true;
    results.value = undefined;
    error.value = undefined;

    const response = await dtwinService.getDtwinsMetricsLifeCycleState(
      organizationCode,
      searchParams.value,
    );

    if (LxcError.check(response)) {
      error.value = response;
    } else {
      results.value = response;
    }
    isLoading.value = false;
  }

  return {
    filters,
    setFilter,
    search,
    onSearch,
    isLoading,
    results,
    error,
    fetchData,
  };
}
